import { FunctionComponent } from 'react'
import SportCompetitorsListComponent from '@components/SportCompetitorsList'
import { validSeasonId, validTypeOfSport } from '@hooks/useSportCompetitorsList'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

export type SportCompetitorsListProps = {
  seasonId: string
  typeOfSport: 'soccer'
}

const SportCompetitorsList: FunctionComponent<SportCompetitorsListProps> = ({
  typeOfSport,
  seasonId,
}) => {
  if (!validSeasonId(seasonId)) {
    return null
  }
  if (!validTypeOfSport(typeOfSport)) {
    return null
  }

  return (
    <SportCompetitorsListComponent
      typeOfSport={typeOfSport}
      seasonId={seasonId}
    />
  )
}

const widget = {
  kind: ['sport-competitors-list'],
  component: SportCompetitorsList,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
